var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { Emitter } from '@tencent/glue-util-emitter';
export var nextTicket = window.requestAnimationFrame
    ? function (fn) { return requestAnimationFrame(fn); }
    : function (fn) { return setTimeout(fn, 16); };
var RenderThread = /** @class */ (function () {
    function RenderThread() {
        this.tasks = [];
        this.isInProgress = false;
    }
    RenderThread.prototype.push = function (task) {
        var instance = task.instance, event = task.event, args = task.args;
        var exist = this.tasks.some(function (existTask) {
            if (existTask.instance === instance && existTask.event === event) {
                // 实例和事件一致的，只更新参数
                existTask.args = args;
                return true;
            }
            return false;
        });
        if (!exist) {
            this.tasks.push(task);
        }
        if (this.tasks.length > 0) {
            this.run();
        }
    };
    RenderThread.prototype.remove = function (task) {
        var instance = task.instance, event = task.event;
        this.tasks = this.tasks.filter(function (existTask) {
            if (existTask.instance === instance) {
                if (!event || event === existTask.event) {
                    // 没有event，或者event相等
                    return false;
                }
            }
            return true;
        });
    };
    RenderThread.prototype.run = function () {
        var _this = this;
        if (this.isInProgress) {
            return;
        }
        this.isInProgress = true;
        nextTicket(function () {
            _this.excuteTasks();
            _this.isInProgress = false;
        });
    };
    RenderThread.prototype.excuteTasks = function () {
        var excuteTasks = __spreadArray([], this.tasks, true);
        this.tasks = [];
        excuteTasks.forEach(function (task) {
            var _a;
            try {
                (_a = task.instance).emit.apply(_a, __spreadArray([task.event], task.args, false));
            }
            catch (err) {
                console.error('Error: ', err);
            }
        });
    };
    return RenderThread;
}());
export { RenderThread };
export var defaultRenderThread = new RenderThread();
var LazyEmitter = /** @class */ (function (_super) {
    __extends(LazyEmitter, _super);
    function LazyEmitter() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    LazyEmitter.prototype.dispose = function () {
        defaultRenderThread.remove({ instance: this });
    };
    LazyEmitter.prototype.emitRenderEvent = function (event) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        defaultRenderThread.push({
            instance: this,
            event: event.toString(),
            args: args,
        });
    };
    return LazyEmitter;
}(Emitter));
export { LazyEmitter };
